// extracted by mini-css-extract-plugin
export default {"dropzone":"Uploader_dropzone__pG8IV","active":"Uploader_active__gDpJd"};